import { ThemeProvider } from '@mui/material/styles';
import { Typography } from '@mui/material';
import theme from './theme';
import { mediaQuery, useMediaQuery } from './mediaQuery.ts';

// style sheet
import './styles.css';

// common_component
import Footer from './components/footer.jsx';
// pc_components
import Header from './components/pc_components/header.jsx';
import ComingSoon from './components/pc_components/coming_soon.jsx';
// sp_components
import Header_sp from './components/sp_components/header.jsx';
import Work from './components/sp_components/work.jsx';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PageError from './components/page_error.jsx';
import NotFound from './components/not_found.jsx';

function App() {
  const isSp = useMediaQuery(mediaQuery.sp)
  if (isSp) {
    return (
      <div className='w-[100%]'>
        <ThemeProvider theme={theme}>
          <Typography>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={
                  <>
                    <Header_sp />
                    <div className='w-[90%] mx-auto'>
                      <p 
                        style={{fontFamily: theme.typography.main_jp.fontFamily}} 
                        className='font-bold px-2 py-1 m-1'
                      >制作物</p>
                      <Work title='Piction' date='2025/03/06' img_path='../../images/logo.png' alt='Piction' path='/Piction'/>
                      <Work title='-------' date='2025/--/--' img_path='' alt='no image' path='/'/>
                    </div>
                    <Footer />
                  </>
                } />
                <Route path="/Piction" element={<PageError /> } />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </Typography>
        </ThemeProvider>
      </div>
    );
  } else {
    return (
      <ThemeProvider theme={theme}>
        <Typography>
          <ComingSoon />
          <Footer />
        </Typography>
      </ThemeProvider>
    )
  }
}

export default App;
